import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, from, Observable, of, switchMap, throwError } from "rxjs";
import { AuthService } from "./auth.service";
import { SessionService } from "../session/session.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private sessionService: SessionService) { }

  private addImpersonationHeader(request: HttpRequest<any>): HttpRequest<any> {
    if (typeof sessionStorage !== "undefined") {
      const impersonateValue = sessionStorage.getItem('Atalef:Impersonate');
      if (impersonateValue) {
        return request.clone({
          setHeaders: {
            'x-atalef-behalf-of': impersonateValue
          }
        });
      }
    }
    return request;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Add impersonation header if needed
    request = this.addImpersonationHeader(request);

    return next.handle(request).pipe(catchError(error => {
      if (error.status === 401) {
        return from(this.authService.tryRefreshToken()).pipe(
          switchMap((res) => {
            return next.handle(this.addNewToken(request, res.access_token ? res.access_token : null));
          }),
          catchError(() => {
            this.sessionService.onUnauthorized();
            return of();
          })
        )
      }
      if (error.status === 503 || error.status === 500) {
        console.log('Server error on POST user: ', error)
        if (!location.host.includes('localhost') && error == "API in maintain mode") {
          this.authService.handleMaintenance()
        } else {
          console.error(error);
        }
      }
      return throwError(error);
    }));
  }

  private addNewToken(request, token) {
    const authHeader = `Bearer ${token}`;
    if (token && authHeader) {
      // Clone the request and add both Authorization and x-atalef-behalf-of headers if needed
      const headers: { [key: string]: string } = { "Authorization": authHeader };
      if (typeof sessionStorage !== "undefined") {
        const impersonateValue = sessionStorage.getItem('Atalef:Impersonate');
        if (impersonateValue) {
          headers['x-atalef-behalf-of'] = impersonateValue;
        }
      }
      return request.clone({ setHeaders: headers });
    }
    return this.addImpersonationHeader(request);
  }
}
